export const STORAGE_KEYS = {
  APP: 'compliance-desk',
  COMPANY: 'company',
}

export const ENDPOINTS = {
  MY_MEMBERSHIPS: 'me/memberships',
  COMPANY_MEMBERSHIPS: 'company/memberships',
  ATTACHMENTS: 'attachments',
  ATTACHMENT_DETAIL: 'attachments/{id}',
  ATTACHMENT_DOWNLOAD: 'attachments/{id}/download',
  NOTE_DETAIL: 'notes/{id}',
  TAGS: 'tags',
  DASHBOARD_METRICS: 'dashboard/metrics',
  COMPANY_DETAIL: 'companies/{id}',
  COMPANY_LOGO: 'companies/{id}/logo',
  COMPANY_SUBSCRIPTIONS: 'companies/{id}/subscriptions',
  COMPANY_BILLING: 'companies/{id}/billing',
  NOTIFICATIONS: 'notifications',
  EMPLOYEES: 'employees',
  EMPLOYEE_DETAIL: 'employees/{id}',
  EMPLOYEE_DEACTIVATE: 'employees/{id}/deactivate',
  EMPLOYEE_COURSES: 'employees/{id}/courses',
  EMPLOYEE_POLICIES: 'employees/{id}/policies',
  EMPLOYEES_IMPORT: 'employees/import',
  EMPLOYEE_ACCESS_INVITATIONS: 'employee_access_invitations',
  POLICY_ACCEPTANCE_SUMMARY: 'policies/acceptance-summary',
  POLICIES: 'policies',
  POLICY_DETAIL: 'policies/{id}',
  POLICY_PUBLISH: 'policies/{id}/publish',
  POLICY_UNPUBLISH: 'policies/{id}/unpublish',
  POLICY_ACCEPT: 'policies/{id}/accept',
  POLICY_ACCEPTANCES: 'policies/{id}/acceptances',
  POLICY_PDF: 'policies/{id}/pdf',
  POLICY_PDF_ACCEPTANCES: 'policies/{id}/pdf/acceptances',
  COURSE_COMPLETION_SUMMARY: 'courses/completion-summary',
  GROUPS: 'groups',
  GROUP_DETAIL: 'groups/{id}',
  GROUP_MEMBERS: 'groups/{id}/members',
  GROUP_MANAGER: 'groups/{id}/manager',
  GROUP_COURSES: 'groups/{id}/courses',
  GROUP_POLICIES: 'groups/{id}/policies',
  GROUP_NOTES: 'groups/{id}/notes',
  GROUP_ATTACHMENTS: 'groups/{id}/attachments',
  SUPPLIERS: 'suppliers',
  SUPPLIER_DETAIL: 'suppliers/{id}',
  SUPPLIER_NOTES: 'suppliers/{id}/notes',
  SUPPLIER_ATTACHMENTS: 'suppliers/{id}/attachments',
  TASKS: 'tasks',
  TASK_DETAIL: 'tasks/{id}',
  TASK_ASSIGNEES: 'tasks/{id}/assignees',
  USERS: 'users',
  COMPLIANCE_PLANS: 'compliance_plans',
  COMPLIANCE_PLAN_DETAIL: 'compliance_plans/{id}',
  COMPLIANCE_PLAN_TASKS: 'compliance-plans/{id}/tasks',
  COMPLIANCE_PLAN_CLOSE_AND_OPEN: 'compliance-plans/{id}/close-and-open',
  COMPLIANCE_PLAN_CALENDAR: 'compliance-plans/{id}/calendar',
  COMPLIANCE_PLAN_RISK_COMPARISON: 'compliance-plans/{id}/risk-comparison',
  AUDIT_LOGS: 'audit_logs',
  NOTIFICATION_READ: 'notifications/{id}/read',
  NOTIFICATION_ACTION: 'notifications/{id}/actions',
  RISK_TABLE: 'risk/table',
  RISK_HEATMAP: 'risk/heatmap',
  CRIMES: 'crimes',
  CRIME_DETAIL: 'crimes/{id}',
  RISK_IMPACTS: 'risk/risk_impacts',
  RISK_IMPACT_DETAIL: 'risk/risk_impacts/{id}',
  RISK_CONCEPTS: 'risk/concepts',
  RISK_CONCEPT_DETAIL: 'risk/concepts/{id}',
  RISK_CONCEPT_EVALUATE: 'risk/concepts/{id}/evaluate',
  RISK_CONCEPTS_EVALUATE_BATCH: 'risk/concepts/evaluate-batch',
  RISK_DRIVERS: 'risk/drivers',
  RISK_DRIVER_CONTEXT: 'risk/drivers/{code}/context',
  RISK_DATA_SOURCES: 'risk/data-sources',
  RISK_DATA_SOURCE_DETAIL: 'risk/data-sources/{id}',
  RISK_DATA_SOURCE_CONFIG: 'risk/data-sources/{dataSourceId}/config',
  RISK_DATA_SOURCE_CONFIG_CREATE: 'risk/data-sources/config',
  RISK_VARIABLES: 'risk/variables',
  RISK_VARIABLE_DETAIL: 'risk/variables/{id}',
  DECLARATIONS: 'declarations',
  DECLARATION_DETAIL: 'declarations/{id}',
  CONTROLS: 'controls',
  CONTROL_DETAIL: 'controls/{id}',
  CONTROL_STATUS: 'controls/{id}/status',
  CONTROL_EVALUATE: 'controls/{id}/evaluate',
  CONTROL_CATEGORIES: 'risk/control-categories',
  CONTROL_CATEGORY_DETAIL: 'risk/control-categories/{id}',
  SURVEYS: 'surveys',
  SURVEY_DETAIL: 'surveys/{id}',
  SURVEY_QUESTIONS: 'surveys/{id}/questions',
  SURVEY_ASSIGNMENTS: 'surveys/{id}/assignments',
  SURVEY_ASSIGNMENT_DETAIL: 'surveys/{id}/assignments/{assignmentId}',
  EMPLOYEE_SURVEY_ASSIGNMENTS: 'employee/survey-assignments',
  EMPLOYEE_SURVEY_ASSIGNMENT_DETAIL: 'employee/survey-assignments/{assignmentId}',
  EMPLOYEE_SURVEY_ASSIGNMENT_RESPONSES: 'employee/survey-assignments/{assignmentId}/responses',
  SURVEY_RESULTS: 'surveys/{id}/results',
  SURVEY_PROGRESS: 'surveys/{id}/progress',
  SURVEY_INSIGHTS: 'surveys/{id}/insights',
  COURSES: 'courses',
  COURSE_DETAIL: 'courses/{id}',
  COURSE_LESSONS: 'courses/{id}/lessons',
  COURSE_TESTS: 'courses/{id}/tests',
  COURSE_QUESTIONS: 'courses/{id}/questions',
  COURSE_ANSWERS: 'courses/{id}/answers',
  COURSE_ENROLLMENTS: 'courses/{id}/enrollments',
  COURSE_PROGRESS: 'courses/{id}/progress',
  ENROLLMENTS: 'enrollments',
  ENROLLMENT_DETAIL: 'enrollments/{id}',
  LESSONS: 'lessons',
  LESSON_DETAIL: 'lessons/{id}',
  ORDERS: 'orders',
  ORDER_DETAIL: 'orders/{id}',
  ORDER_ITEMS: 'orders/{id}/items',
  ORDER_ITEM_DETAIL: 'order-items/{id}',
  ORDER_CHECKOUT: 'orders/{id}/checkout',
  LICENSES: 'licenses',
}

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
} as const;
